import { createSlice } from '@reduxjs/toolkit';

import { getItem, storeItem } from '../helpers/store';

const STORAGE_ID = 'main-menu-state';

const initialize = () => {
  const width = window.screen.availWidth < window.innerWidth ? window.screen.availWidth : window.innerWidth;

  if (width < 990) {
    return false;
  }

  const stored = getItem(STORAGE_ID);

  if (stored === null) {
    return true;
  }

  return stored === 'true';
};

const initialState = {
  isOpen: initialize(),
  menuOpen: true,
  sections: {
    jobBoard: false,
    lists: true,
  },
};

export const mainMenuSlice = createSlice({
  name: 'mainMenu',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      const newState = !state.isOpen;
      // eslint-disable-next-line no-param-reassign
      state.isOpen = newState;
      storeItem(STORAGE_ID, newState);
    },
    setMenuOpen: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.menuOpen = action.payload;
    },
    toggleSection: (state, action) => {
      const key = action.payload;
      if (state.sections && Object.prototype.hasOwnProperty.call(state.sections, key)) {
        // eslint-disable-next-line no-param-reassign
        state.sections[key] = !state.sections[key];
      }
    },
  },
});

export const { toggleMenu, setMenuOpen, toggleSection } = mainMenuSlice.actions;

export default mainMenuSlice.reducer;
